import Vue from 'vue'
import state from './state'

Vue.prototype.$store = Vue.observable(state)